import { useSyncExternalStore } from 'react';
import i18n from './i18n';
import { isAppLanguageCode, type AppLanguageCode } from './i18n/languages';

/** Normalize i18n language codes (`ar-SA` → `ar`) to a supported app locale. */
export function resolveAppLanguage(code: string | undefined | null): AppLanguageCode {
  const primary = String(code ?? '')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  return primary && isAppLanguageCode(primary) ? primary : 'en';
}

function subscribeUiLocale(onStoreChange: () => void) {
  const handler = () => onStoreChange();
  i18n.on('languageChanged', handler);
  return () => {
    i18n.off('languageChanged', handler);
  };
}

function getUiLocaleSnapshot(): AppLanguageCode {
  return resolveAppLanguage(i18n.language || i18n.resolvedLanguage);
}

function getUiLocaleServerSnapshot(): AppLanguageCode {
  return 'en';
}

/** Subscribe to UI language changes (works with translateUi call sites via remount keys). */
export function useUiLocale(): AppLanguageCode {
  return useSyncExternalStore(subscribeUiLocale, getUiLocaleSnapshot, getUiLocaleServerSnapshot);
}
